import React from 'react';
import PropTypes from 'prop-types';

const Elevator = ({ color = '#224251', ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" viewBox="0 0 24 24" {...props}>
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M20.26 21H4V2h16.26v19Z" clipRule="evenodd" />
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" d="M4 2h16.26M12 21V5M4 5h16.26" />
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.6} d="m14.8 12 1.5-1.5 1.5 1.5" />
    <path stroke={color} strokeLinecap="round" strokeWidth={0.8} d="M16.3 11v4" />
    <path stroke={color} strokeLinecap="round" strokeLinejoin="round" strokeWidth={0.6} d="M6.5 13.5 8 15l1.5-1.5" />
    <path stroke={color} strokeLinecap="round" strokeWidth={0.8} d="M8 10.5v4" />
  </svg>
);

Elevator.propTypes = {
  color: PropTypes.string
};

export default Elevator;
